import React, { Component } from "react";
import Logo from "../../../shared/logo";
import SignInFooter from "../../../shared/footer/signinFooter";

import styles from "./toRestorePassword.module.scss";
import ToRestorePasswordForm from "./ToRestorePasswordForm";
import ButtonRestoreSendMailWrapper from "./ButtonRestoreSendMailWrapper";

class ToRestorePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className={styles.restoreWrapper}>
        <div className={styles.restoreForm}>
          <div className={styles.logo_container}>
            <Logo />
          </div>
          <ToRestorePasswordForm />

          <div className={styles.linkSignIn}>
            <a href="/">На страницу входа</a>
          </div>

          <div className={styles.button_container}>
            <ButtonRestoreSendMailWrapper />
          </div>
        </div>

        <SignInFooter />
      </div>
    );
  }
}

export default ToRestorePassword;
